/**
 * Brevitē Custom Nav v2.1
 * File: assets/custom-nav.js
 * Handles: review carousel, desktop mega menu, Brevitē Custom popover + Inside Brevitē dropdown
 */

(function () {
  'use strict';

  /* Shared so the mega panel and the right-side popovers close each other */
  var closeMegaFn = function () {};
  var closeAllPopsFn = function () {};

  /* ═══ REVIEW CAROUSEL ═══ */
  function initReviews() {
    /* Support multiple instances (drawer + mega) */
    document.querySelectorAll('[data-cn-reviews]').forEach(function (container) {
      var reviews = container.querySelectorAll('[data-cn-review]');
      var dots = container.querySelectorAll('[data-cn-dot]');
      if (reviews.length < 2) return;

      var current = 0;
      var timer = null;

      function show(index) {
        reviews.forEach(function (r, i) {
          r.classList.toggle('cn-review--active', i === index);
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('cn-review-dot--active', i === index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        current = index;
      }

      function next() { show((current + 1) % reviews.length); }
      function startTimer() { stopTimer(); timer = setInterval(next, 5000); }
      function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(this.getAttribute('data-cn-dot'), 10));
          startTimer();
        });
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { startTimer(); } else { stopTimer(); }
        });
      }, { threshold: 0.1 });

      observer.observe(container);
    });
  }

  /* ═══ DESKTOP MEGA MENU ═══ */
  function initMegaMenu() {
    var mega = document.querySelector('[data-cn-mega]');
    if (!mega) return;

    var closeBtn = mega.querySelector('[data-cn-mega-close]');
    var isOpen = false;
    var hoverTimeout = null;

    /* Find the top menu link that opens the panel.
       Its title is set in Customize → Header → "Top menu link that opens the panel"
       and arrives here as data-cn-trigger. */
    var triggerText = (mega.getAttribute('data-cn-trigger') || 'shop').trim().toLowerCase();
    var shopLink = null;
    var headerNav = document.querySelector('.header__inline-menu, .header--has-menu');
    if (!headerNav) headerNav = document.querySelector('.header');

    if (headerNav) {
      var allLinks = headerNav.querySelectorAll(
        'a.header__menu-item, summary.header__menu-item, .list-menu__item--link, a.menu-drawer__menu-item'
      );
      allLinks.forEach(function (link) {
        var text = link.textContent.trim().toLowerCase();
        if (!shopLink && text === triggerText) {
          shopLink = link;
        }
      });

      /* Also check details > summary elements (Dawn mega/dropdown) */
      if (!shopLink) {
        var summaries = headerNav.querySelectorAll('details summary');
        summaries.forEach(function (sum) {
          var text = sum.textContent.trim().toLowerCase();
          if (!shopLink && text === triggerText) {
            shopLink = sum;
          }
        });
      }
    }

    function openMega() {
      if (isOpen) return;
      closeAllPopsFn();
      mega.style.display = '';
      isOpen = true;
      if (shopLink) shopLink.setAttribute('aria-expanded', 'true');
      /* Close Dawn's own dropdowns if any are open */
      document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    }

    function closeMega() {
      if (!isOpen) return;
      mega.style.display = 'none';
      isOpen = false;
      if (shopLink) shopLink.setAttribute('aria-expanded', 'false');
    }

    function toggle() {
      if (isOpen) { closeMega(); } else { openMega(); }
    }

    closeMegaFn = closeMega;

    if (shopLink) {
      /* Prevent default Dawn dropdown behavior */
      shopLink.addEventListener('click', function (e) {
        /* Only intercept on desktop */
        if (window.innerWidth < 990) return;
        e.preventDefault();
        e.stopPropagation();
        toggle();

        /* If this is a <summary> inside <details>, prevent it from opening */
        var parentDetails = shopLink.closest('details');
        if (parentDetails) {
          parentDetails.removeAttribute('open');
        }
      });

      /* Hover behavior — open on hover with small delay */
      shopLink.addEventListener('mouseenter', function () {
        if (window.innerWidth < 990) return;
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(openMega, 150);
      });

      shopLink.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimeout);
      });

      /* Add ARIA */
      shopLink.setAttribute('aria-haspopup', 'true');
      shopLink.setAttribute('aria-expanded', 'false');
      shopLink.classList.add('cn-shop-trigger');
    }

    /* Close on overlay click */
    if (closeBtn) {
      closeBtn.addEventListener('click', closeMega);
    }

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeMega();
        if (shopLink) shopLink.focus();
      }
    });

    /* Keep mega open when hovering over it */
    var panel = mega.querySelector('.cn-mega__panel');
    if (panel) {
      panel.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimeout);
      });
      panel.addEventListener('mouseleave', function () {
        hoverTimeout = setTimeout(closeMega, 300);
      });
    }

    /* Close mega when hovering other nav items */
    if (headerNav) {
      var otherLinks = headerNav.querySelectorAll(
        'a.header__menu-item, summary.header__menu-item, .list-menu__item--link'
      );
      otherLinks.forEach(function (link) {
        if (link === shopLink) return;
        link.addEventListener('mouseenter', function () {
          if (window.innerWidth >= 990) closeMega();
        });
      });
    }
  }

  /* ═══ RIGHT-SIDE POPOVERS (Brevitē Custom, Inside Brevitē) ═══ */
  function initPopovers() {
    var pops = Array.prototype.slice.call(document.querySelectorAll('[data-cn-pop]'));
    if (!pops.length) return;

    function parts(pop) {
      return { btn: pop.querySelector('[data-cn-pop-toggle]'), panel: pop.querySelector('[data-cn-pop-panel]') };
    }
    function close(pop) {
      var p = parts(pop);
      if (!p.panel || p.panel.hidden) return;
      p.panel.hidden = true;
      p.btn.setAttribute('aria-expanded', 'false');
    }
    function open(pop) {
      pops.forEach(function (other) { if (other !== pop) close(other); });
      closeMegaFn();
      var p = parts(pop);
      p.panel.hidden = false;
      p.btn.setAttribute('aria-expanded', 'true');
    }
    closeAllPopsFn = function () { pops.forEach(close); };

    pops.forEach(function (pop) {
      var p = parts(pop);
      if (!p.btn || !p.panel) return;
      p.btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (p.panel.hidden) { open(pop); } else { close(pop); }
      });
      /* Close when keyboard focus leaves the popover */
      pop.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !pop.contains(e.relatedTarget)) close(pop);
      });
    });

    document.addEventListener('click', function (e) {
      pops.forEach(function (pop) { if (!pop.contains(e.target)) close(pop); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      pops.forEach(function (pop) {
        var p = parts(pop);
        if (p.panel && !p.panel.hidden) { close(pop); p.btn.focus(); }
      });
    });

    /* Theme editor: open the popover when one of its blocks is selected */
    document.addEventListener('shopify:block:select', function (e) {
      var pop = e.target.closest && e.target.closest('[data-cn-pop]');
      if (pop) open(pop);
    });
    document.addEventListener('shopify:block:deselect', function () { closeAllPopsFn(); });
  }

  /* ═══ INIT ═══ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReviews();
      initMegaMenu();
      initPopovers();
    });
  } else {
    initReviews();
    initMegaMenu();
    initPopovers();
  }
})();
